"use client";

import { useEffect } from "react";
import { track } from "@/lib/analytics";

export function PageViewTracker({ slug }: { slug: string }) {
  useEffect(() => {
    track("page_view", { merchantSlug: slug });
  }, [slug]);

  return null;
}
